import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M10.4 3.6a2.7 2.7 0 0 0-2.7 2.7v9.75a4.35 4.35 0 1 0 8.7 0V5.93a.6.6 0 1 1 1.2 0v10.12a5.55 5.55 0 1 1-11.1 0V6.3a3.9 3.9 0 0 1 7.8 0v9.701a2.25 2.25 0 0 1-4.5 0V7.186a.6.6 0 1 1 1.2 0v8.815a1.05 1.05 0 1 0 2.1 0V6.3a2.7 2.7 0 0 0-2.7-2.7Z"
      clip-rule="evenodd"
    />
  </svg>
`;
